<template>
  <div class="container">
    <el-row style="margin-bottom:10px" type="flex" align="middle" justify="space-between">
      <el-col  style="font-weight:bolder;color:rgb(30,119,202);font-size:1.2em">待办事项</el-col>
      <el-col  style="text-align:right;font-size:1em;color:rgb(30,119,202)"><a style="cursor: pointer;" @click="more">更多></a></el-col>
    </el-row>
    <el-row v-for="item in toDoList" :key="item.id" type="flex" align="middle" justify="space-between">
      <el-col :span="18" style="font-size:0.9em;height:30px;line-height:30px;display:flex;align-items: center">
        <div style="width: 5px;  height: 5px;  margin: 0 5px;   border-top: 1px solid red; border-right: 1px solid red; transform: rotate(45deg);" />
        <a style="cursor: pointer;" @click="openFlow(item)"><ellipsis :length="36">{{ item.showName +'的'+ item.processDefinitionName }}</ellipsis></a>
      </el-col>
      <el-col :span="6" style="text-align:right;font-size:0.9em;">{{  formatDateByStatsType(item.processInstanceStartTime) }}</el-col>
    </el-row>
    <el-row v-if="toDoList.length==0" type="flex" justify="center">
      <el-empty :image-size="100" />
    </el-row>
  </div>
</template>

<script>
import '@/staticDict/flowStaticDict.js';
import {statsDateRangeMixin } from '@/core/mixins';
import FlowOperationController from '@/api/FlowController/FlowOperationController';
import Ellipsis from '../Ellipsis/Ellipsis'
import {mapMutations} from 'vuex';
export default {
  name: 'UserStatic',
  components: { Ellipsis },
  data () {
    return {
      toDoList: []
    }
  },
  mixins: [statsDateRangeMixin],
  created () {
    this.loadTaskData()
  },
  mounted () {
  },
  methods: {
    openFlow (row) {
      let params = {
        processInstanceId: row.processInstanceId,
        processDefinitionId: row.processDefinitionId,
        taskId: row.taskId
      }

      FlowOperationController.viewRuntimeTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: true,
              isDraft: row.isDraft,
              taskId: row.taskId,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: row.taskName,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              // 过滤掉加签操作，加签只有在已完成任务里可以操作
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              }),
              variableList: res.data.variableList
            }
          });
        }
      }).catch(e => {});
    },
    more () {
      this.$router.replace({
        name: 'formMyTask'
      });

      this.setCurrentMenuId('1418059167532322816');
    },
    loadTaskData () {
      let params = {}
      params.pageParam = {
        pageNum: 1,
        pageSize: 8
      }
      return new Promise((resolve, reject) => {
        FlowOperationController.listRuntimeTask(this, params).then(res => {
          console.info('res', res)
          this.toDoList = res.data.dataList
        }).catch(e => {
          reject(e);
        });
      });
    },
    ...mapMutations([
      'setCurrentMenuId'
    ])
  }
}
</script>

<style lang="scss" scoped>
  .container{
    padding:20px;
    font-family: sans-serif;
    height:310px
  }

</style>
